/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class CreditRatingDialog extends SiteEntityDialog<CreditRatingRow, any> {
        protected getFormKey() { return CreditRatingForm.formKey; }
        protected getIdProperty() { return CreditRatingRow.idProperty; }
        protected getLocalTextPrefix() { return CreditRatingRow.localTextPrefix; }
        protected getNameProperty() { return CreditRatingRow.nameProperty; }
        protected getService() { return CreditRatingService.baseUrl; }

        protected form = new CreditRatingForm(this.idPrefix);

    }
}